import React from 'react';
import ManualInstitution from '../../components/ManualInstitution/ManualInstitution';
import PhoneNumber from '../../components/PhoneNumber/PhoneNumber';
import { CartContextProvider } from '../../context/CartContext/CartContext';

const ManualInstitutionScreen = ({ appState }) => {
  const {
    store: { amount }
  } = appState;

  return (
    <CartContextProvider
      initialTotalAmount={amount}
      initialPercentMode
      initialFunds={[]}>
      <div>
        <ManualInstitution />
        <PhoneNumber />
      </div>
    </CartContextProvider>
  );
};

export default ManualInstitutionScreen;
